import Backbone from '@rover/globals/backbone';

export default Backbone.Model.extend({});



// WEBPACK FOOTER //
// ./js/backbone/models/RelationshipModel.js